import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { EKeyCode } from '@/enums/e_key_code';
import { use_effect } from '@/hooks/_base/use_effect';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { useState } from 'react';
import { scan, setOptions } from 'react-scan';
import { WATCHER_SHORTCUT__base } from '../shortcuts/_watchers/WATCHER_SHORTCUT__base';

export function WatcherReactScanShowHide() {
  const [is_react_scan_visible, set_is_react_scan_visible] = useState(false);

  /*
   * EFFECTS
   */

  use_effect(() => scan({ showToolbar: false }), []);

  use_effect(() => {
    setOptions({ enabled: false, showToolbar: CONSTANTS__environment_client.VITE_APP_ENVIRONMENT === ENUM__environment_type.LOCAL && is_react_scan_visible });
  }, [is_react_scan_visible]);

  /*
   * EVENTS
   */

  function on_shortcut_pressed() {
    set_is_react_scan_visible(!is_react_scan_visible);

    return true;
  }

  /*
   * HTML
   */
  if (CONSTANTS__environment_client.VITE_APP_ENVIRONMENT !== ENUM__environment_type.LOCAL) return null;

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.S, EKeyCode.ControlLeft]} {...{ on_shortcut_pressed }} />;
}
